var map = {
  "./legacy.sv.json": [
    "42771",
    [
      80016
    ]
  ],
  "./legacy.cs.json": [
    "35100",
    [
      21741
    ]
  ],
  "./legacy.lt.json": [
    "18330",
    [
      82759
    ]
  ],
  "./legacy.pt.json": [
    "14414",
    [
      97987
    ]
  ],
  "./legacy.hu.json": [
    "78209",
    [
      65658
    ]
  ],
  "./legacy.et.json": [
    "40447",
    [
      74132
    ]
  ],
  "./legacy.it.json": [
    "85507",
    [
      3840
    ]
  ],
  "./legacy.fr.json": [
    "36602",
    [
      5223
    ]
  ],
  "./legacy.ja.json": [
    "81303",
    [
      74364
    ]
  ],
  "./legacy.nl.json": [
    "78516",
    [
      19541
    ]
  ],
  "./legacy.sl.json": [
    "37589",
    [
      70358
    ]
  ],
  "./legacy.fi.json": [
    "44547",
    [
      54688
    ]
  ],
  "./legacy.pl.json": [
    "63670",
    [
      55995
    ]
  ],
  "./legacy.de.json": [
    "39149",
    [
      33918
    ]
  ],
  "./legacy.es.json": [
    "34434",
    [
      38559
    ]
  ],
  "./legacy.no.json": [
    "14497",
    [
      634
    ]
  ],
  "./legacy.en.json": [
    "37601",
    [
      8506
    ]
  ],
  "./legacy.da.json": [
    "92153",
    [
      87362
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 42105;
module.exports = __rspack_async_context;
